document.addEventListener('DOMContentLoaded', function() {

  /* -----------------------------------
      CORE FUNCTIONS
  ----------------------------------- */

  const protectionVariantId = 52110598242604;

  const getCart = () => fetch('/cart.js').then(res => res.json());

  const addProtection = () =>
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: protectionVariantId, quantity: 1 })
    });

  const removeProtection = () =>
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [protectionVariantId]: 0 } })
    });

  const hasProtection = (cart) =>
    cart.items.some(item => item.variant_id === protectionVariantId);

  const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  /* -----------------------------------
      SPINNER CSS
  ----------------------------------- */
  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
    .checkout-spinner {
      display: inline-block;
      width: 16px; height: 16px;
      border: 2px solid #fff;
      border-top-color: transparent;
      border-radius: 50%;
      margin-right: 8px;
      vertical-align: middle;
      animation: spin 0.8s linear infinite;
    }
  `;
  document.head.appendChild(style);

  /* -----------------------------------
      LOADING HANDLERS
  ----------------------------------- */
  const startLoading = (button, text = 'Processing...') => {
    if (!button) return;
    button.dataset.originalText = button.innerHTML;
    button.innerHTML = `<span class="checkout-spinner"></span>${text}`;
    button.disabled = true;
  };

  const stopLoading = (button) => {
    if (!button) return;
    if (button.dataset.originalText) {
      button.innerHTML = button.dataset.originalText;
      button.disabled = false;
    }
  };

  /* -----------------------------------
      MAIN LISTENER ATTACHER
  ----------------------------------- */
  const attachListeners = () => {
    const protectionCheckbox = document.querySelector('#checkout-without-protection');
    const checkoutLink = document.querySelector('#CartDrawer-Checkout');

    /* ---- CHECKBOX HANDLER ---- */
    if (protectionCheckbox && !protectionCheckbox.dataset.bound) {
      protectionCheckbox.dataset.bound = 'true';

      protectionCheckbox.addEventListener('change', async function() {
        startLoading(checkoutLink, 'Updating...');

        try {
          const cart = await getCart();
          const hasItem = hasProtection(cart);

          // FIXED LOGIC:
          // CHECKED → ADD
          if (this.checked && !hasItem) {
            await addProtection();
            await wait(1000);
          }

          // UNCHECKED → REMOVE
          if (!this.checked && hasItem) {
            await removeProtection();
            await wait(1000);
          }

        } catch (err) {
          console.error('Error updating protection:', err);
        } finally {
          stopLoading(checkoutLink);
        }
      });
    }

    /* ---- CHECKOUT BUTTON HANDLER ---- */
    if (checkoutLink && !checkoutLink.dataset.bound) {
      checkoutLink.dataset.bound = 'true';

      checkoutLink.addEventListener('click', async function (e) {
        e.preventDefault();
        startLoading(checkoutLink, 'Proceeding...');

        try {
          const cart = await getCart();
          const hasItem = hasProtection(cart);

          const wantsNoProtection =
            protectionCheckbox && protectionCheckbox.checked;

          // IF USER CHECKED THE BOX → DO NOT ADD PROTECTION
          if (wantsNoProtection) {
            if (hasItem) {
              await removeProtection();
              await wait(1000);
            }

            window.location.href = '/checkout';
            return;
          }

          // IF USER DID NOT CHECK → ALWAYS ADD PROTECTION
          if (!hasItem) {
            await addProtection();
            await wait(1000);
          }

          window.location.href = '/checkout';

        } catch (err) {
          console.error('Checkout error:', err);
          window.location.href = '/checkout';
        }
      });
    }

  };

  attachListeners();

  /* Watch DOM for new elements in drawer */
  const observer = new MutationObserver(() => attachListeners());
  observer.observe(document.body, { childList: true, subtree: true });

  /* -----------------------------------
      TOOLTIP
  ----------------------------------- */
  var image = document.querySelector(".tooltip-onhover");
  var box = document.querySelector(".tooltip-content");

  if (image && box) {
    image.addEventListener("mouseenter", () => box.style.display = "block");
    image.addEventListener("mouseleave", () => box.style.display = "none");

    if (window.innerWidth <= 768) {
      let isVisible = false;
      image.addEventListener("click", () => {
        isVisible = !isVisible;
        box.style.display = isVisible ? "block" : "none";
      });
    }
  }

});
